export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,

  title: '发货通知-信息确认',
} as TCommon.RouteConfig
